import React, { useState } from 'react'

import { useColumns } from './columns'
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getExpandedRowModel,
  getSortedRowModel,
  useReactTable,
  getPaginationRowModel,
} from '@tanstack/react-table'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../lib/ui/table'
import { useCoachDashboard } from '../../CoachDashboardProvider'
import { cn } from '../../../../lib/utils'

export function UpcomingMeetingsDataTable() {
  const { unfilteredDashboardData } = useCoachDashboard()
  const columns = useColumns()
  const upcomingMeetings =
    unfilteredDashboardData && unfilteredDashboardData.meetings
      ? unfilteredDashboardData.meetings
      : []
  const [expanded, setExpanded] = useState({})
  const [globalFilter, setGlobalFilter] = useState('')
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  })
  const table = useReactTable({
    debugTable: true,
    data: upcomingMeetings || [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getRowCanExpand: () => true,
    state: {
      expanded,
      globalFilter,
      pagination,
    },
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: 'includesString',
    enableMultiSorting: true,
    onExpandedChange: setExpanded,
    getExpandedRowModel: getExpandedRowModel(),
    onPaginationChange: setPagination,
    getPaginationRowModel: getPaginationRowModel(),
  })

  return (
    <>
      <div className="rounded-2xl border border-alto-200">
        <Table tableClass="rounded-2xl">
          <TableHeader className="rounded-2xl bg-intoo-green-coachcta">
            {table.getHeaderGroups().map((headerGroup) => (
              <TableRow
                key={`${headerGroup.id}-header_group`}
                className="border-alto-200 bg-intoo-green-coachcta p-4 text-white  hover:bg-intoo-green-coachcta sm:px-8 sm:py-6"
              >
                {headerGroup.headers.map((header) => {
                  return (
                    <TableHead
                      key={`${header.id}-header`}
                      className="job-search-table-header h-6 pl-0 text-sm font-bold text-foreground data-[col-id=status]:w-[96px] sm:h-12 sm:px-4 data-[col-id=status]:sm:w-[120px]"
                      data-col-id={header.column.id}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                    </TableHead>
                  )
                })}
              </TableRow>
            ))}
          </TableHeader>
          <TableBody>
            {table.getPaginationRowModel().rows?.length ? (
              table
                .getPaginationRowModel()
                .rows.map((row, index) => (
                  <DataTableRow
                    key={`${row.id}-table_row`}
                    row={row}
                    index={index}
                  />
                ))
            ) : (
              <TableRow className="p-4 sm:px-8 sm:py-6">
                <TableCell colSpan={columns.length + 2} className="h-24">
                  <div className="flex flex-col items-center justify-center">
                    <div className="max-w-96 text-center">
                      <p>
                        You&apos;re all set! You have no meetings or events.
                      </p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {upcomingMeetings.length > 5 && (
          <div className="flex items-center justify-between p-4">
            <button
              className="rounded border px-3 py-1 disabled:opacity-50"
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              Previous
            </button>
            <span>
              Page {table.getState().pagination.pageIndex + 1} of{' '}
              {table.getPageCount()}
            </span>
            <button
              className="rounded border px-3 py-1 disabled:opacity-50"
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </>
  )
}

const DataTableRow = ({ row, ...props }) => {
  const { index } = props
  return (
    <>
      <TableRow
        fred={5}
        className={
          (cn('border-alto-200'),
          index % 2 === 1
            ? 'bg-alto-50 hover:bg-alto-50'
            : '!hover:bg-white !bg-white')
        }
        {...props}
      >
        {row.getVisibleCells().map((cell) => (
          <TableCell
            key={`${row.id}_${cell.id}`}
            className="pb-2 pl-0 pr-0 pt-3 sm:p-4 sm:pr-1"
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    </>
  )
}
